import { t } from 'ttag'
import { useMutation } from 'react-query'

import { api, errors } from '@h2/api'
import { useForm } from '@h2/common/components/hooks/useForm'
import { TextArea } from '@h2/components/inputs/textArea'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Button } from '@h2/components/buttons/button'
import { Field } from '@h2/components/inputs/field'
import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'
import { TimesCircleIcon } from '@h2/components/icons'

const RejectionActionsContent = ({ assignmentId, toggleModal, onSuccess }) => {
  const {
    register: registerRejectionForm,
    isInvalid: isInvalidRejectionForm,
    handleOnSubmit: handleOnSubmitRejectionForm,
    dispatch: dispatchRejectionForm,
    error
  } = useForm({
    reason(form) {
      if (!form.reason?.trim()) {
        return t`The reason for the rejection must be included for the explorer.`
      }
    }
  })
  const { mutate: mutateRejection, isLoading: isRejectionLoading } = useMutation(
    body =>
      api.fetch(`/management/assignments/reject/${assignmentId}`, {
        method: 'PUT',
        body: JSON.stringify(body)
      }),
    {
      onSuccess: assignmentResponse => {
        assignmentResponse.affectedPlans.forEach(assignment => onSuccess(assignment))
        toggleModal()
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatchRejectionForm({ type: 'validate', payload: formErrors })
        }
      }
    }
  )

  return (
    <div>
      <form onSubmit={handleOnSubmitRejectionForm(form => mutateRejection(form))}>
        <Field
          required={true}
          desc={error.reason}
          status={error.reason ? 'error' : 'default'}
          label={t`Rejection Reason`}>
          <TextArea
            placeholder={t`Describe for the explorer why you are rejecting this.`}
            {...registerRejectionForm('reason', { required: true })}
          />
        </Field>
        <Flex justifyContent="space-between">
          <Box width="250px">
            <Button
              type="submit"
              size="large"
              align="center"
              isLoading={isRejectionLoading}
              isDisabled={isRejectionLoading || isInvalidRejectionForm}>
              {t`Reject`}
            </Button>
          </Box>
        </Flex>
      </form>
    </div>
  )
}
const RejectionActions = ({ assignmentId, isOpen, toggleModal, onSuccess }) => {
  return (
    <Modal isOpen={isOpen} closeOnClickOverlay={true} onClose={toggleModal}>
      <Modal.Header>
        <Heading level="3">
          <TimesCircleIcon /> {t`Reject`}
        </Heading>
      </Modal.Header>
      <Modal.Body>
        <RejectionActionsContent
          assignmentId={assignmentId}
          toggleModal={toggleModal}
          onSuccess={onSuccess}
        />
      </Modal.Body>
    </Modal>
  )
}

export { RejectionActions }
